<div *ngIf="!showQuizLeaderboard" class="quiz-component d-flex align-items-center justify-content-center">
  <div
    class="card w-100 h-100 mb-0 p-1 p-md-3 my-3"
    style="max-width: 80%; max-height: 80%; background-color: white"
  >
    <div class="card-body">
      <div class="content-wrapper">
        <!-- mobile start -->
        <div class="d-sm-block d-md-none">
          <div class="d-flex align-items-center justify-content-between">
            <img
              src="../../../assets/img/xi.svg"
              height="25"
              class="cursor-pointer"
              alt=""
              style="width: fit-content"
              (click)="dismissQuiz()"
            />
            <div>
              <p class="mb-0 font-weight-bolder font-medium-5 text-center">Quiz</p>
            </div>
            <div class="d-flex align-items-center">
              <img src="../../../../../assets/img/bolt.png" alt="" />
              <p class="mb-0 text-black font-medium-3 font-weight-bolder">
                {{ currentQuestion?.qNumber }}/{{ quiz?.numberOfQuestions }}
              </p>
            </div>
          </div>
        </div>
        <!-- end -->
        <div class="d-none d-md-block">
          <div class="d-flex align-items-center justify-content-between">
            <img
              src="../../../assets/img/xi.svg"
              height="40"
              class="cursor-pointer"
              alt=""
              style="width: fit-content"
              (click)="dismissQuiz()"
            />
            <div>
              <h4 class="quiz-title text-center">Quiz</h4>
              <p class="quiz-subtitle text-center">
                Fill in the blank with the correct preposition
              </p>
            </div>
            <div class="d-flex align-items-center">
              <img src="../../../../../assets/img/bolt.png" alt="" />
              <p class="mb-0 text-black font-medium-3 font-weight-bolder">
                {{ currentQuestion?.qNumber }}/{{ quiz?.numberOfQuestions }}
              </p>
            </div>
          </div>
          <div
            class="progress custom-progress m-2"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              class="progress-bar filled-progress"
              [style.width]="progressBarPercentage + '%'"
            ></div>
          </div>
        </div>
        <div class="">
          <ng-container *ngIf="isLoadingQuestions; else notLoading">
            <div
              class="d-flex justify-content-center align-items-center"
              style="height: 60vh"
            >
              <div class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </ng-container>
          <ng-template #notLoading>
            <ng-container
              *ngIf="
                quiz.questions && quiz.questions.length > 0;
                else noQuestions
              "
            >
              <h4 class="text-dark" *ngIf="currentQuestion.isMultipleChoiced">
                Hint: <small>Please select all that apply</small>
              </h4>
              <div class="question-section">
                <p class="mt-3 mb-3" [innerHTML]="currentQuestion?.prompt"></p>
                <img
                  *ngFor="let image of currentQuestion?.questionMediaDTOList"
                  [src]="image.media"
                  alt="Question Img"
                  class="mb-2 img-fluid"
                />
                <div
                  class="form-check p-1 mb-2 mt-2"
                  [ngClass]="{
                    'is-correct':
                      answer.isSelected &&
                      currentQuestion?.givenAnswer &&
                      currentQuestion?.correctlyAnswered,
                    'is-wrong':
                      answer.isSelected &&
                      currentQuestion?.givenAnswer &&
                      !currentQuestion?.correctlyAnswered
                  }"
                  *ngFor="let answer of currentQuestion?.answerDTOS"
                  (click)="setSelectedAnswer(answer.answerId, $event)"
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <fieldset [disabled]="ansIsSubmitted">
                        <input
                          class="form-check-input"
                          [type]="currentQuestion.isMultipleChoiced ? 'checkbox' : 'radio'"
                          [name]="'question' + currentQuestion.questionId"
                          [id]="'flexRadioDefault2' + answer.answerId"
                          [value]="answer.answerId"
                          (change)="setSelectedAnswer(answer.answerId)"
                          (click)="$event.stopPropagation()"
                        />
                        <label
                          class="form-check-label ml-2"
                          [for]="'flexRadioDefault2' + answer.answerId"
                          [innerHTML]="answer.prompt"
                          (click)="$event.stopPropagation()"
                        >
                        </label>
                      </fieldset>
                      <img
                        *ngFor="
                          let image of currentQuestion?.answerDTOS
                            ?.answerMediaDTOList
                        "
                        [src]="image.media"
                        [class]="
                          (currentQuestion?.answerDTOS?.answerMediaDTOList
                            ?.length
                            ? 'mb-0'
                            : 'mb-1') + 'img-fluid'
                        "
                        alt="Description Img"
                      />
                    </div>
                    <img
                      *ngIf="
                        answer.isSelected &&
                        currentQuestion?.givenAnswer &&
                        currentQuestion?.correctlyAnswered
                      "
                      src="../../../../../assets/img/right.png"
                      alt=""
                      class="answer-indicator"
                    />

                    <img
                      *ngIf="
                        answer.isSelected &&
                        currentQuestion?.givenAnswer &&
                        !currentQuestion?.correctlyAnswered
                      "
                      src="../../../../../assets/img/wrong.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <button
                class="btn btn-primary btn-block mt-1 mb-3"
                (click)="checkAnswer()"
                *ngIf="!currentQuestion?.givenAnswer"
                [disabled]="!selectedAnswer.length"
              >
                Submit Answer
              </button>
              <!-- correct and wrong answers -->
              <ng-container
                *ngIf="
                  hasSelectedAnswer &&
                  (!currentQuestion?.correctlyAnswered ||
                    currentQuestion?.correctlyAnswered)
                "
              >
                <div
                  class="answer-details mt-5 d-flex align-items-center"
                  [ngClass]="{
                    isCorrect: this.currentQuestion?.correctlyAnswered,
                    isWrong: !this.currentQuestion?.correctlyAnswered
                  }"
                >
                  <div class="description-text flex-1">
                    <h3 class="mb-2">
                      {{
                        this.currentQuestion.correctlyAnswered
                          ? "Great...That's Correct!"
                          : "Oops...That's Incorrect"
                      }}
                    </h3>
                    <ng-container
                      *ngIf="!this.currentQuestion.correctlyAnswered"
                    >
                      <p>Answer:</p>
                      <p
                        class="mb-2 font-medium-2"
                        [innerHTML]="
                          'The correct answer is ' +
                          currentQuestion?.correctAnswers[0]?.prompt
                        "
                      ></p>
                    </ng-container>
                    <ng-container *ngIf="this.currentQuestion?.description">
                      <p>Answer Description:</p>
                      <p
                        class="mb-0 font-medium-2"
                        [innerHTML]="this.currentQuestion?.description"
                      ></p>
                      <img
                        *ngFor="
                          let image of currentQuestion?.descriptionMediaDTOS
                        "
                        [src]="image.media"
                        [class]="
                          currentQuestion?.descriptionMediaDTOS?.length
                            ? 'mb-0'
                            : 'mb-1'
                        "
                        alt="Description Img"
                      />
                    </ng-container>
                  </div>
                  <img
                    [src]="
                      this.currentQuestion.correctlyAnswered
                        ? '../../../../../assets/img/bep.png'
                        : '../../../../../assets/img/Component 12.png'
                    "
                    height="200"
                    alt=""
                  />
                </div>
              </ng-container>

              <div
                *ngIf="currentQuestion?.givenAnswer"
                class="d-flex align-items-baseline mt-3"
                [ngClass]="{
                  'justify-content-end': firstQuestion,
                  'justify-content-between': !firstQuestion,
                  'd-none': firstQuestion
                }"
              >
                <button
                  class="btn btn-outline-primary"
                  [ngClass]="{ 'd-none': firstQuestion }"
                  (click)="togglePreviousQuestion()"
                  style="background-color: transparent"
                >
                  Previous
                </button>
                <button
                  class="btn btn-primary"
                  [ngClass]="{ 'd-none': lastQuestion }"
                  (click)="toggleNextQuestion()"
                >
                  Next
                  <i
                    data-feather="arrow-right"
                    class="align-middle ml-sm-25 ml-0"
                  ></i>
                </button>
              </div>
            </ng-container>
          </ng-template>
          <ng-template #noQuestions>
            <ngb-alert [type]="'success'" [dismissible]="false">
              <div class="alert-body">
                There are no questions for this topic at the moment.
              </div>
            </ngb-alert>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<app-quiz-leaderboard-move *ngIf="showQuizLeaderboard"></app-quiz-leaderboard-move>
<!-- <div class="p-3" *ngIf="quiz">
  <ng-container *ngIf="quiz.questions && quiz.questions.length > 0; else noQuestions">
    <div>
      <div class="card mt-50">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between">
            <img src="../../../assets/img/learning.png" height="50" alt="learning logo" />
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="feather feather-x-square" style="cursor: pointer" (click)="dismissQuiz()">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="9" y1="9" x2="15" y2="15"></line>
              <line x1="15" y1="9" x2="9" y2="15"></line>
            </svg>
          </div>
          <div class="quiz-heading">
            <h4 class="text-center mb-0">QUIZ</h4>
            <p class="text-center fw-bolder">
              Fill out the Trivia quiz for fun!
            </p>
          </div>
          <div class="progressbar mb-2">
            <ng-container *ngIf="currentQuestion.isMultipleChoiced; else singleChoice">
              <div class="d-flex flex-row align-items-center justify-content-between">
                <h4 class="text-dark">
                  Hint: <small>Please select all that apply</small>
                </h4>
                <h4 class="text-dark">
                  Question {{ currentQuestion?.qNumber }} of
                  {{ quiz?.numberOfQuestions }}
                </h4>
              </div>
            </ng-container>
            <ng-template #singleChoice>
              <div class="d-flex align-items-center justify-content-end">
                <h4 class="text-dark">
                  Question {{ currentQuestion?.qNumber }} of
                  {{ quiz?.numberOfQuestions }}
                </h4>
              </div>
            </ng-template>
            <div class="progress custom-progress" role="progressbar" aria-label="Basic example" aria-valuenow="50"
              aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar filled-progress" [style.width]="progressBarPercentage + '%'"></div>
            </div>
          </div>
          <p [innerHTML]="currentQuestion?.prompt" [class]="
              currentQuestion?.questionMediaList?.length ? 'mb-0' : 'mb-1'
            "></p>
          <img *ngFor="let image of currentQuestion?.questionMediaDTOList" [src]="image.media" alt="Question Img"
            class="mb-2" />


          <div *ngFor="let answer of currentQuestion?.checkList" [class]="
              'form-check ' +
              (answer.isSelected ? 'bg-grey ' : '') +
              (answer.isSelected &&
              currentQuestion?.givenAnswer &&
              currentQuestion?.correctlyAnswered
                ? 'bg-green '
                : '') +
              (answer.isSelected &&
              currentQuestion?.givenAnswer &&
              !currentQuestion?.correctlyAnswered
                ? 'bg-red '
                : '')
            " (click)="setSelectedAnswer(answer.value)">
            <fieldset [disabled]="hasSelectedAnswer">
              <input class="form-check-input" type="checkbox" [id]="'answerBox' + answer.value" [value]="answer.value"
                [checked]="answer.isSelected" [disabled]="hasSelectedAnswer" />
              <label class="form-check-label" (click)="labelClick($event)"
                *ngIf="answer.a.prompt.length > 0 && answer.a.prompt != '.'" [innerHTML]="answer.a.prompt">
              </label>
            </fieldset>
            <img *ngFor="
                let image of currentQuestion?.answerDTOS?.answerMediaDTOList
              " [src]="image.media" [class]="
                currentQuestion?.answerDTOS?.answerMediaDTOList?.length
                  ? 'mb-0'
                  : 'mb-1'
              " alt="Description Img" />


          </div>
          <ng-container *ngIf="hasSelectedAnswer && !currentQuestion?.correctlyAnswered">
            <lottie-player src="https://lottie.host/8737d7dd-81ac-4893-bdb2-3467c9f6d574/k8Mq5Dff6S.json"
              background="transparent" speed="1" style="height: 10rem" loop autoplay></lottie-player></ng-container>
          <ng-container *ngIf="hasSelectedAnswer && currentQuestion?.correctlyAnswered">
            <lottie-player src="https://lottie.host/c2392240-440a-4423-8c01-4b21c5706daf/i44MQRdRef.json"
              background="transparent" speed="1" style="height: 10rem" loop autoplay></lottie-player>
          </ng-container>

          <ngb-alert [type]="'success'" [dismissible]="false" class="mt-1" *ngIf="
              currentQuestion?.givenAnswer &&
              !currentQuestion?.correctlyAnswered
            ">
            <h4 class="alert-heading">The correct answer is:</h4>
            <div class="alert-body">
              <p [innerHTML]="currentQuestion?.correctAnswers[0].prompt"></p>
            </div>
          </ngb-alert>
        </div>
      </div>
      <div class="card mt-1" *ngIf="currentQuestion?.givenAnswer">
        <div class="card-body">
          <ngb-alert [type]="'secondary'" [dismissible]="false" class="mt-1">
            <h4 class="alert-heading">Answer Description:</h4>
            <div class="alert-body">
              <p [innerHTML]="currentQuestion?.description"></p>
              <img *ngFor="let image of currentQuestion?.descriptionMediaDTOS" [src]="image.media" [class]="
                  currentQuestion?.descriptionMediaDTOS?.length
                    ? 'mb-0'
                    : 'mb-1'
                " alt="Description Img" />
            </div>
          </ngb-alert>
        </div>
      </div>

      <button type="button" class="btn btn-primary" rippleEffect (click)="checkAnswer()"
        *ngIf="!currentQuestion?.givenAnswer" [disabled]="!selectedAnswer.length">
        Check
      </button>

      <div class="mb-1 d-flex justify-content-between" *ngIf="currentQuestion?.givenAnswer">
        <button type="button" class="btn btn-primary" rippleEffect (click)="togglePreviousQuestion()"
          [class]="{ 'd-none': firstQuestion }">
          <i data-feather="arrow-left" class="align-middle ml-sm-25 ml-0"></i>
          Previous
        </button>
        <button type="button" class="btn btn-secondary" rippleEffect (click)="toggleNextQuestion()"
          [class]="{ 'd-none': lastQuestion }">
          Next
          <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #noQuestions>
    <ngb-alert [type]="'success'" [dismissible]="false">
      <div class="alert-body">
        There are no questions for this topic at the moment.
      </div>
    </ngb-alert>
  </ng-template>
</div> -->
